import { Box, IconButton } from "@mui/material";
import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import CopyIcon from "@common/svgs/copy.svg?react";
import { useRiskObservationPublicLinkDialogDataMapping } from "./RiskObservationPublicLinkDialog.hooks";

export interface IRiskObservationPublicLinkDialogProps {
    onDialogClose: () => void;
}

function RiskObservationPublicLinkDialog(props: IRiskObservationPublicLinkDialogProps) {
    const { translateString } = useTranslation();
    const { isLoading, isActive, shareUrl, isToggling, makeActive, makeInactive, copyShareLink } = useRiskObservationPublicLinkDialogDataMapping();

    return (
        <DotLegalDialog
            open
            size="md"
            header={translateString("reportObservationLink")}
            buttonOkText={isActive ? translateString("makeNotPublic") : translateString("makePublic")}
            okButtonStyle="primary"
            onOkClick={isActive ? makeInactive : makeActive}
            inProgress={isLoading || isToggling}
            onDialogClose={props.onDialogClose}
            secondaryButtonText={translateString("close")}
            secondaryButtonStyle="secondary"
            onSecondaryButtonClick={props.onDialogClose}
        >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                <DotLegalHeader headerStyle="small" fontWeight={400} center marginBottom={0}>
                    {isActive ? translateString("reportObservationLinkActiveDescription") : translateString("reportObservationLinkDescription")}
                </DotLegalHeader>
                {shareUrl && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
                        <Box
                            sx={{
                                flex: 1,
                                padding: "8px 12px",
                                border: "0.5px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                fontSize: 13,
                                wordBreak: "break-all",
                                background: (theme) => theme.palette.grey[100],
                            }}
                        >
                            {shareUrl}
                        </Box>
                        <IconButton onClick={copyShareLink} title={translateString("copyLink")}>
                            <CopyIcon />
                        </IconButton>
                    </Box>
                )}
            </Box>
        </DotLegalDialog>
    );
}

export default RiskObservationPublicLinkDialog;
